import { gql } from 'graphql.macro';

export const meTemplate = gql`
    query me {
        me {
            _id
            email
            name
        }
    }
`;

export const loginTemplate = gql`
    mutation login($email: String!, $password: String!, $totpCode: String!) {
        login(email: $email, password: $password, totpCode: $totpCode) {
            _id
            email
            name
        }
    }
`;

export const logoutTemplate = gql`
    mutation logout {
        logout
    }
`;
